import React from 'react';
import Navbar from '../components/Navbar';
import { Mail } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 overflow-hidden">
      {/* Mobile Navbar */}
      <div className="md:hidden">
        <Navbar dark={false} mobile={true} />
      </div>
      
      {/* Desktop Navbar */}
      <div className="hidden md:block">
        <Navbar dark={false} />
      </div>
      
      <div className="container mx-auto px-8 py-16 max-w-4xl">
        {/* Contacts */}
        <div className="flex flex-col items-center pl-10 space-y-6 mb-20">
          <div className="flex flex-col space-y-6 mb-20">
            <p className="text-2xl font-light mb-8">
                Fastest contact channel: 
                <a 
                    href="mailto:rarkhmammadova22@ku.edu.tr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center space-x-3 text-xl font-light text-gray-800 hover:underline transition-all"
                >
                    <Mail className="w-6 h-6" />
                    <span>rarkhmammadova22@ku.edu.tr</span>
                </a>
            </p>

            <p className="text-2xl font-light mb-8">
                Personal email: 
                <a 
                    href="mailto:royaarkh@gmail.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center space-x-3 text-xl font-light text-gray-800 hover:underline transition-all"
                >
                    <Mail className="w-6 h-6" />
                    <span>royaarkh@gmail.com</span>
                </a>
            </p>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Contact;